import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { keyboardLayout } from "utils/uiData";
import Api from "utils/wApi/index";
import Cookie from "js-cookie";
import useCart from "store";

// components
import Layout from "layout/index";
import { SvgIconStyle, CommonInput } from "components";
import { Typography, Box, Button, Snackbar } from "@mui/material";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";

// asset
import BackIcon from "assets/icons/back.svg";

// ----------------------------------------------------------------------

export default function AdminLoginPage() {
	const navigate = useNavigate();
	const KIOSK_ID = Cookie.get("Kiosk_ID");
	const {
		setFestival,
		setStandByImg,
		setBranchLargeList,
		setBranchMidList,
		setBranchSmallList,
		setMenuList,
		removeAllCart,
	} = useCart((state) => state);

	const keyboard = useRef();

	// id : 페스티벌 아이디 / pw : 7353 (법인폰 뒷자리)
	const [inputValue, setInputValue] = useState({ id: null, pw: null });
	const [focused, setFocused] = useState("id");
	const [snackbarState, setSnackbarState] = useState({ open: false, text: "" }); // 토스트알림 온오프

	const onSubmit = async () => {
		const body = {
			loginId: inputValue.id,
			password: inputValue.pw,
			device: KIOSK_ID,
		};

		try {
			const { data } = await Api.adminLogin(body);
			setFestival(data);
			// 데이터 초기화
			setBranchLargeList([]);
			setBranchMidList([]);
			setBranchSmallList([]);
			setMenuList([]);
			removeAllCart();
			// ===== 키오스크 대기화면 =====
			try {
				const adCategory = `kiosk_standby_${data.branchId}`;
				const { data: adStandBy } = await Api.ad(null, adCategory, {});

				setStandByImg(adStandBy.imageUrl);
			} catch (error) {
				setStandByImg("");
			}

			navigate("/admin/setting");
		} catch (e) {
			setSnackbarState({ open: true, text: e });
			setTimeout(() => {
				setSnackbarState({ open: false, text: "" });
			}, 500);
			return;
		}
	};

	useEffect(() => {
		if (!keyboard.current) return;
		keyboard.current.clearInput();
		switch (focused) {
			case "id":
				keyboard.current.setInput(inputValue.id);
				break;
			case "pw":
				keyboard.current.setInput(inputValue.pw);
				break;
			default:
				break;
		}
	}, [focused]);

	return (
		<Layout sx={{ px: 6, pt: 4.5 }}>
			<Box sx={{ display: "flex", justifyContent:'space-between',alignItems: "center", }}>
				<Box sx={{ display: "flex", gap: 4 }}>
				<Box onClick={() => navigate("/")} sx={{ mt: 1 }}>
					<SvgIconStyle src={BackIcon} origin size={20} />
				</Box>
				<Typography variant="h2">관리자 페이지</Typography>
				</Box>
				<Typography variant="h1" color={'primary.main'} >{ KIOSK_ID}</Typography>
			</Box>

			<Box sx={{ display: "flex", flexDirection: "column", gap: 6, p: 6 }}>
				<Box
					sx={{
						width: "100%",
						display: "flex",
						alignItems: "flex-end",
						justifyContent: "space-between",
					}}
				>
					<Typography variant="h5">아이디</Typography>
					<CommonInput
						autoComplete="off"
						value={inputValue.id}
						onClick={() => setFocused("id")}
						sx={{
							width: "300px",
							height: "fit-content",
							letterSpacing: 30,
							input: {
								fontSize: "60px !important",
								textAlign: "right",
								borderBottom: "1px solid #000 !important",
							},
							fieldset: { height: "115px !important", border: 0 },
						}}
					/>
				</Box>
				<Box
					sx={{
						width: "100%",
						display: "flex",
						alignItems: "flex-end",
						justifyContent: "space-between",
					}}
				>
					<Typography variant="h5">비밀번호</Typography>
					<CommonInput
						type="password"
						autoComplete="off"
						value={inputValue.pw}
						onClick={() => setFocused("pw")}
						sx={{
							width: "300px",
							height: "fit-content",
							letterSpacing: 30,
							input: {
								fontSize: "60px !important",
								textAlign: "right",
								borderBottom: "1px solid #000 !important",
							},
							fieldset: { height: "115px !important", border: 0 },
						}}
					/>
				</Box>
			</Box>

			<Box
				sx={{
					".hg-button": {
						minHeight: "120px",
						fontSize: "1.5rem",
					},
					pt: 10,
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					gap: 6,
				}}
			>
				<Keyboard
					keyboardRef={(el) => (keyboard.current = el)}
					layoutName={"numeric"}
					layout={{ ...keyboardLayout }}
					onChange={(value) => {
						switch (focused) {
							case "id":
								setInputValue((prev) => ({ ...prev, id: value }));
								break;
							case "pw":
								setInputValue((prev) => ({ ...prev, pw: value }));
								break;
							default:
								break;
						}
					}}
				/>

				<Button variant="contained" sx={{ px: 5 }} onClick={() => onSubmit()}>
					<Typography variant="subtitle1">입력하기</Typography>
				</Button>
			</Box>

			{/* toast */}
			<Snackbar
				anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
				open={snackbarState.open}
				message={snackbarState.text}
			/>
			{/* toast */}
		</Layout>
	);
}
